import React from 'react';
import { View } from 'react-native-web';
import StepPoint from './StepPoint';
import { Android } from '../../../../utils/DictionaryManagementUtils';

//= ========================================================================

const SelectColorStepPoint = ({
  globJSON, simPlatform, numOfPointThatGetColor,
}) => {
  const ArrayOfPoints = [1, 2, 3, 4];
  const { colors } = globJSON.configurations.theme;

  const setPointColor = () => ArrayOfPoints.map((item) => (
    <StepPoint
      globJSON={globJSON}
      backgroundColor={
        numOfPointThatGetColor === item ? colors.primary_font_color : colors.tertiary_icons_color
}
    />
  ));

  return (
    <View style={{
      justifyContent: 'space-between',
      flexDirection: 'row',
      paddingHorizontal: '37%',
      marginTop: simPlatform === Android ? 15 : 35,
      marginBottom: simPlatform !== Android && 50,
      zIndex: 1,
    }}
    >
      {setPointColor(ArrayOfPoints)}
    </View>
  );
};
export default SelectColorStepPoint;
